import React, { useEffect, useState, useContext } from "react";
import { fetchJson } from "../fetch.js";
import * as BookPageHelpers from './helpers.js';
import * as Helpers from '../helpers.mjs';
import { useElasticData, useExtraData } from "./DataContext.js";
import OtherEditions from './OtherEditions.js';
import { SearchContext } from "../components/SearchContext.js";

const DenseTables = () => {

    let { elasticData, productData, bindings, broadbindings, bookBands, keywords, ukslcCodes, altEditions } = useElasticData();
    let { extraData, _source, _annotation, bookAwardsArray } = useExtraData();
    let { doCustomSearch, doSearchTermSearch } = useContext(SearchContext);

    const pds = elasticData;
    let productRrp = new Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(pds.rrp);

    const [keywordProductCountData, setKeywordProductCountData] = useState(null);

    useEffect(() => {
        // Get keyword product count
        const fetchKeywordProductCount = (kIds) => {
            fetchJson("/tag/getKeywordTitleCounts/" + kIds).then((json) => {
                var results = json;
                setKeywordProductCountData(results);
            });
        }

        if(_source.keywords?.length > 0) {
            var keywordIds = _source.keywords.map((k) => k.value);
            fetchKeywordProductCount(keywordIds.join(","));
        }
    }, []);

    function getEditionTooltip(edition) {

        let editionTooltip = false;

        switch (edition) {
            case "Bind-up":
            case "Bind-Up":
                editionTooltip = "Multiple titles published in a single volume, where each title has been previously published alone.";
                break;
            case "First":
                editionTooltip = "Not previously published, available for the first time with a hardback cover";
                break;
            case "Import":
            case "Import - New in UK":
                editionTooltip = "Originally published outside of the UK";
                break;
            case "Large":
                editionTooltip = "Giant size, used for group storytelling or sharing";
                break;
            case "Large Print":
                editionTooltip = "Set in large type (such as 18 point or larger), especially for use by the partially sighted";
                break;
            case "New":
                editionTooltip = "Previously available but the information has been updated or reworked, or the basic format has changed";
                break;
            case "New Cover Reprint":
                editionTooltip = "Reissued with a new ISBN and a new cover, but no changes to content";
                break;
            case "New in Paperback":
            case "New in paperback":
                editionTooltip = "Previously published as a hardback, now available in a paperback format for the first time";
                break;
            case "Original":
                editionTooltip = "Not previously published, available for the first time with a paperback cover";
                break;
            case "Reprint":
                editionTooltip = "Reissued with a new ISBN, with no changes to the content";
                break;
            case "Rights Reversion":
                editionTooltip = "New edition as the publishing rights have transferred back to the author, or to a new publisher";
                break;
            case "Simultaneous":
                editionTooltip = "Not previously available, published in two formats at the same time (usually hardback and paperback)";
                break;
            default:
                break;
        }

        return editionTooltip ? `<span className="searchToolTip">${editionTooltip}</span>` : "";
    }
    const bookbandsArray = _source.productcategorylinks ? _source.productcategorylinks.filter(c => bookBands[c]).map(c => <li><span className={`swatch cat${c}`} title={bookBands[c]}>{bookBands[c]}</span></li>) : [];

    const keywordLinkArray = _source.keywords ? _source.keywords.filter(k => keywords[k.value]).map((k, i, kwArray) => <li title={keywordProductCountData && `Browse ${parseInt(keywordProductCountData[k.value] - 1).toLocaleString()} other titles with this keyword`}>
        <a onClick={e => {
            e.preventDefault();
            doCustomSearch([{ filter: "filters[keywords][selectedKeyword]", value: k.value }]);
        }}>{keywords[k.value]}</a>{i !== (kwArray.length - 1) ? "," : ""}</li>) : [];

    const UKSLCLink = ({ code, type }) => <p className="needMore"><a onClick={e => {
        e.preventDefault();
        doCustomSearch([{ filter: `filters[ukslc][${type}][value]`, value: code }]);
    }}>{code}</a><span className="searchToolTip">{ukslcCodes[code]}</span></p>

    var ukslcLinkArray = [];
    if (_source.ukslc_age?.value) {
        ukslcLinkArray.push(<UKSLCLink code={_source.ukslc_age.value} type="age" />);
    }
    if (_source.ukslc_audience?.length > 0) {
        _source.ukslc_audience.map(a => a.value && ukslcLinkArray.push(<UKSLCLink code={a.value} type="audience" />));
    }
    if (_source.ukslc_subject?.value) {
        ukslcLinkArray.push(<UKSLCLink code={_source.ukslc_subject.value} type="subject" />);
    }
    if (_source.ukslc_treatment?.value) {
        ukslcLinkArray.push(<UKSLCLink code={_source.ukslc_treatment.value} type="treatment" />);
    }
    if (_source.ukslc_booktype) {
        ukslcLinkArray.push(<UKSLCLink code={_source.ukslc_booktype} type="booktype" />);
    }
    if (_source.ukslc_broad_subject?.value) {
        ukslcLinkArray.push(<UKSLCLink code={_source.ukslc_broad_subject.value} type="broad_subject" />);
    }
    if (_source.ukslc_genre?.value) {
        ukslcLinkArray.push(<UKSLCLink code={_source.ukslc_genre.value} type="genre" />);
    }

    // const ukslcLinkArray = ukslcArray.length !== 0 ? ukslcArray.map((uc, ui) => <>
    //     <p className="needMore"><a onClick={() => {
    //         doCustomSearch([{filter:"filters[ukslc][value]", value: uc}]);
    //     }}>{uc}</a><span className="searchToolTip">{ukslcCodes[uc]}</span></p>{ui + 1 < ukslcArray.length ? "," : ""}
    // </>) : [];

    const hasCustomerDewey = extraData && extraData?.customerDewey && extraData?.customerDewey != "";
    var bookNotes = _annotation != "" ? _annotation[_annotation.length - 1].replace("NOTE :", "NOTE:") : "";
    var notePos = bookNotes.indexOf("NOTE:");
    var bookNotes = notePos !== -1 ? bookNotes.slice(notePos + 5) : null;

    const bibText = (_source.bib_tag && _source.bib_tag !== "" && _source.bib_tag?.length > 300) ? (_source.bib_tag.substring(0, 300).trim() + "...") : _source.bib_tag;

    var formatString = "";
    if (_source.binding && bindings[_source.binding] == "Spiral") {
        formatString = "Spiral bound";
    } else if (_source.broad_binding != "O" && broadbindings) {
        formatString = broadbindings[_source.broad_binding];
    } else {
        formatString = bindings[_source.binding];
    }
    const format = formatString;

    // Check if review & BOTW text match?
    var botwText = _source.botw_review_any?.replace(/<[^>]+>/g, '');
    var specialCharacters =
    {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#039;': "'"
    };

    botwText = botwText?.replace(/&amp;|&lt;|&gt;|&quot;|&#039;/g, function(m) {return specialCharacters[m];});

    return (
        <>
            <div className="denseTables">
                <div>
                    <table className="denseBookTable">
                        <tbody>
                            {_source.id && <tr>
                                <td className="heading">ISBN</td>
                                <td>
                                    {extraData && extraData.opacLink && <a target="_blank" title="Open in your OPAC" href={extraData && extraData.opacLink}>{_source.id}</a>}
                                    {(!extraData || !extraData.opacLink) && <>{_source.id}</>}
                                </td>
                            </tr>}
                            {_source.stmt_responsibility && <tr>
                                <td className="heading">Statement of responsibility</td>
                                <td>{_source.stmt_responsibility.charAt(0).toUpperCase()}{_source.stmt_responsibility.slice(1)}</td>
                            </tr>}
                            {_source.series_display && <tr>
                                <td className="heading">Series</td>
                                <td><a onClick={e => {
                                    e.preventDefault();
                                    doSearchTermSearch(`"${_source.series_display}"`, "series");
                                }}>{_source.series_display}{_source.volume ? ` (${_source.volume})` : ``}</a> </td>
                            </tr>}
                            {productRrp && <tr>
                                <td className="heading">RRP</td>
                                <td>{productRrp}</td>
                            </tr>}
                            {_source.binding && <tr>
                                <td className="heading">Format</td>
                                <td>{format}</td>
                            </tr>}

                            {_source.category && <tr>
                                <td className="heading">Category</td>
                                <td>{_source.category}</td>
                            </tr>}
                            {_source.peters_subject && <tr>
                                <td className="heading">Subject</td>
                                <td>{_source.peters_subject}</td>
                            </tr>}
                            {_source.dewey && <tr>
                                <td className="heading">Dewey</td>
                                <td>{_source.dewey}</td>
                            </tr>}
                            {hasCustomerDewey && <tr>
                                <td className="heading">Customer dewey</td>
                                <td>{extraData?.customerDewey}</td>
                            </tr>}
                            {!!BookPageHelpers.getAgeLevelsText(_source.lower_reading_age, _source.upper_reading_age) && <tr>
                                <td className="heading">Reading age</td>
                                <td>{BookPageHelpers.getAgeLevelsText(_source.lower_reading_age, _source.upper_reading_age)}</td>
                            </tr>}
                            {!!BookPageHelpers.getAgeLevelsText(_source.lower_interest_age, _source.upper_interest_age) && <tr>
                                <td className="heading">Interest level</td>
                                <td>{BookPageHelpers.getAgeLevelsText(_source.lower_interest_age, _source.upper_interest_age)}</td>
                            </tr>}
                            {_source.publisher.title && _source.publisher.title != "UNKNOWN" && <tr>
                                <td className="heading">Publisher</td>
                                <td>
                                    <a onClick={e => {
                                        e.preventDefault();
                                        doSearchTermSearch(_source.publisher.title, "pub");
                                    }}>{_source.publisher.title}</a>
                                </td>
                            </tr>}
                            {_source.imprint && _source.imprint.title != "" && _source.imprint.title != _source.publisher.title && _source.imprint.title != "UNKNOWN" && <tr>
                                <td className="heading">Imprint</td>
                                <td>
                                    <a onClick={e => {
                                        e.preventDefault();
                                        doSearchTermSearch(_source.imprint.title, "pub");
                                    }}>{_source.imprint.title}</a>
                                </td>
                            </tr>}
                            {!!(_source.publish_date) && <tr>
                                <td className="heading">Pub. date</td>
                                <td>{BookPageHelpers.getFormattedDate(_source.publish_date)}</td>
                            </tr>}
                            {!!(_source.release_date) && _source.release_date != _source.publish_date && _source.release_date != "0001-01-01T00:00:00Z" && <tr>
                                <td className="heading">Release date</td>
                                <td>{BookPageHelpers.getFormattedDate(_source.release_date)}</td>
                            </tr>}
                            {!!(_source.edition) && <tr>
                                <td className="heading">Edition</td>
                                <td>
                                    <p className="needMore">
                                        {_source.edition} {getEditionTooltip(_source.edition) && <span className="searchToolTip" dangerouslySetInnerHTML={{ __html: getEditionTooltip(_source.edition) }} />} </p>
                                </td>
                            </tr>}
                            {!!(_source.country_of_pub) && <tr>
                                <td className="heading">Country of pub.</td>
                                <td>{_source.country_of_pub}</td>
                            </tr>}
                            {!!(_source.pages) && <tr>
                                <td className="heading">Pages</td>
                                <td>{_source.pages}</td>
                            </tr>}
                            {ukslcLinkArray.length > 0 && <tr>
                                <td className="heading">UKSLC</td>
                                <td>{ukslcLinkArray.map(u => <>{u}&nbsp;</>)}</td>
                            </tr>}
                            {!!(_source.book_level) && <tr>
                                <td className="heading">AR™</td>
                                <td>{_source.book_level} {_source.ar_interest_level}</td>
                            </tr>}
                            {bookbandsArray.length > 0 && <tr>
                                <td className="heading">Book banding</td>
                                <td>
                                    <ul className="bookBanding">{bookbandsArray}</ul>
                                </td>
                            </tr>}
                        </tbody>
                    </table>
                </div>
                <div>
                    <div className="denseBookInfo">
                        <div className="denseBookTableContainer">
                            <table className="denseBookTable">
                                <tbody>
                                    {!_source.isbookpack && extraData !== null && <tr>
                                        <td>
                                            <p><strong>Availability</strong></p>
                                            {<p><em dangerouslySetInnerHTML={{ __html: Helpers.getStockMessage(pds) }}></em></p>}
                                        </td>
                                    </tr>}
                                    {_source.botw_review_any && <tr>
                                        <td>
                                            <p><strong>Book of the week</strong></p>
                                            {<div dangerouslySetInnerHTML={{__html: _source.botw_review_any}}></div>}
                                        </td>
                                    </tr>}
                                    {bibText && bibText !== "" && <tr>
                                        <td>
                                            <p><strong>Summary</strong></p>
                                            <p>{bibText}</p>
                                        </td>
                                    </tr>}
                                    {keywordLinkArray.length > 0 && <tr>
                                        <td>
                                            <strong>Theme keywords</strong><br />
                                            <ul className="linksList">{keywordLinkArray}</ul>
                                        </td>
                                    </tr>}
                                    {altEditions.length > 0 && <tr>
                                        <td>
                                            <OtherEditions />
                                        </td>
                                    </tr>}
                                </tbody>
                            </table>
                            <div>
                                <table className="denseBookTable">
                                    <tbody>
                                        {_source.advisory_note && <tr>
                                            <td>
                                                <p><strong>Content advisory</strong></p>
                                                <p>{_source.advisory_note}</p>

                                            </td>
                                        </tr>}
                                        {bookAwardsArray.length > 0 && <tr>
                                            <td>
                                                <p><strong>Awards</strong></p>
                                                <p>{bookAwardsArray}</p>
                                            </td>
                                        </tr>}

                                        {bookNotes != null && <tr>
                                            <td>
                                                <p><strong>Notes</strong></p>
                                                <p>{bookNotes}</p>
                                            </td>
                                        </tr>}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default DenseTables;